import { SortOrder } from "../sort-order";

export class TemplateFilters {
  name: string;
  description: string;
  deviceCategoryNames: string[];
  types: string[];
  tenantUuids: string[];
  creationRangeDates: number[];
  updateRangeDates: number[];
  sortField: string;
  sortOrder: SortOrder;
}
